var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(-1301 -310)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 86,
    height: 86,
    rx: 43,
    transform: "translate(1301 310)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Back_Nav",
    "data-name": "Back Nav",
    d: "M.321,21.024,20.753.331a1.112,1.112,0,0,1,1.56-.023l4.294,4.1a1.113,1.113,0,0,1,.025,1.585L11.856,21.03a1.113,1.113,0,0,0,0,1.558L26.62,37.674a1.113,1.113,0,0,1-.042,1.6L22.31,43.2a1.113,1.113,0,0,1-1.542-.035L.323,22.59A1.113,1.113,0,0,1,.321,21.024Z",
    transform: "translate(1357.78 374.516) rotate(180)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.3e50c3e1dac9e6ce164d38b975295913.svg";
export { ForwardRef as ReactComponent };